import isEmpty from "lodash/isEmpty"
import { useRouter } from "next/router"
import { BlueGradientButton } from "@rentspree/component-v2/dist/button/gradient"
import RedText from "components/atoms/red-text"
import SpaceBetweenWrapper from "components/atoms/space-between-wrapper"
import { Text } from "components/atoms/typography"
import WhiteButton from "components/atoms/white-button"
import { COLOR } from "styles/style-constants"
import ButtonWithAnimation from "../button-with-animation"

const ButtonSet = ({
  previous = {},
  next = {},
  importantAsterisk = true,
  importantNote,
  loading,
  color = COLOR.lightGray,
  beforeContent,
  beforeColor = COLOR.lightGray,
  ...rest
}) => {
  const router = useRouter()
  const { partner } = router.query

  const isScreeningOptionPage = router.pathname === "/[partner]"

  const {
    label: previousLabel,
    onClick: previousOnClick = () => {},
    disabled: previousDisabled,
    id: prevBtnId,
  } = previous
  const {
    label: nextLabel,
    type: nextType,
    onClick: nextOnClick = () => {},
    disabled: nextDisabled,
    id: nextBtnId,
  } = next
  return (
    <SpaceBetweenWrapper width="100%" mt={"32"} {...rest}>
      {!isEmpty(previous) && (
        <WhiteButton
          type="button"
          id={prevBtnId}
          semiBold
          fontSize="16px"
          leftIcon
          small
          margin="0"
          minWidth="100"
          onClick={previousOnClick}
          disabled={previousDisabled}>
          {previousLabel}
        </WhiteButton>
      )}
      {importantNote && (
        <Text
          size="12px"
          margin="0px"
          color={color}
          beforeContent={beforeContent}
          beforeColor={beforeColor}>
          {importantAsterisk && <RedText>* &nbsp;</RedText>}
          {importantNote}
        </Text>
      )}
      {isScreeningOptionPage ? (
        <ButtonWithAnimation
          id={nextBtnId}
          type={nextType}
          label={nextLabel}
          loading={loading}
          onClick={nextOnClick}
          disabled={nextDisabled}
        />
      ) : (
        <BlueGradientButton
          id={nextBtnId}
          small
          semiBold
          margin="0"
          minWidth="100"
          fontSize="16px"
          hasIcon
          type={nextType}
          loading={loading}
          onClick={nextOnClick}
          disabled={nextDisabled}>
          {nextLabel}
        </BlueGradientButton>
      )}
    </SpaceBetweenWrapper>
  )
}

export default ButtonSet
